import { MandateStatus, MatchStatus } from '@brickup/shared/constants'
import {
  FILTER_ALL,
  oneOf,
  stringFilter,
  type AllOr,
  type FilterDef,
} from '@/components/Internal/DataTable'

type MandateStatusFilter = AllOr<MandateStatus.ACTIVE | MandateStatus.PAUSED>

export const mandateListFilters = {
  status: {
    // Paused mandates are dormant by definition, so the list opens on the
    // active ones and "reset" returns there.
    ...oneOf<MandateStatusFilter>(
      [FILTER_ALL, MandateStatus.ACTIVE, MandateStatus.PAUSED],
      MandateStatus.ACTIVE,
    ),
    // Only `all` narrows nothing, so `active` reaches the API like any other
    // value; the API has no notion of an opening view.
    clearedValue: FILTER_ALL,
  } satisfies FilterDef<MandateStatusFilter>,

  /** The advisor the mandate names, by `User.uuid` — which is what an
   *  `AdvisorCardDto` carries. The projects list filters the same person by
   *  `User.id`, so the two are not one filter under one name. */
  advisor: stringFilter<string>(FILTER_ALL),

  search: stringFilter(),

  /** The mandate whose matches the sidebar lists. In the URL so a property's
   *  detail pane can link straight at the customer it was matched to. */
  selected: {
    ...stringFilter(),
    countsAsFilter: false,
    resettable: false,
  } satisfies FilterDef<string>,

  /** Which of the selected mandate's matches the sidebar shows. New ones are
   *  what the screen exists for, so it opens on those. */
  matchStatus: {
    ...oneOf<MatchStatus>(Object.values(MatchStatus), MatchStatus.POSSIBLE),
    countsAsFilter: false,
  } satisfies FilterDef<MatchStatus>,
}
